import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import '../../css/StartPage.css'

const AboutProject = () => {
	const { t } = useTranslation('startPage')
	const [isOpen, setIsOpen] = useState(false)

	return (
		<section className='about-section'>
			<button
				className='about-toggle'
				onClick={() => setIsOpen(prev => !prev)}
				aria-expanded={isOpen}
			>
				<span>{t('aboutProject.title')}</span>
				<ChevronDown size={18} className={`about-chevron ${isOpen ? 'open' : ''}`} />
			</button>

			{isOpen && (
				<div className='about-text'>
					<p>{t('aboutProject.paragraph1')}</p>

					<p>{t('aboutProject.paragraph2')}</p>

					<p>{t('aboutProject.paragraph3')}</p>

					<p>{t('aboutProject.paragraph4')}</p>

					<p>{t('aboutProject.paragraph5')}</p>

					<p className='about-signature'>{t('aboutProject.signature')}</p>
				</div>
			)}
		</section>
	)
}

export default AboutProject
